import { GameType, RingGameType } from "../store/game/types/Game";

export default function isRingGameType(
  gameType: GameType,
): gameType is RingGameType {
  return gameType === "cash" || gameType === "snap";
}
